"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SendButton = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SendButton = function SendButton() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "14",
    height: "12",
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0.5 12L13.5 6L0.5 0V4.66666L9.8125 6L0.5 7.33334V12Z",
    fill: "black",
    fillOpacity: "0.33"
  }));
};
exports.SendButton = SendButton;